import { configureStore } from "@reduxjs/toolkit";
import phoneReducer from "../pages/phone/redux/phoneSlice";
import quoteReducer from "../pages/quote/redux/quoteSlice";

const store = configureStore({
  reducer: {
    phone: phoneReducer,
    quote: quoteReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
